import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import Form from '../../components/Form';
import { SuiCheckbox as Checkbox } from '../../components/Checkbox';
import messages from './messages';

import './styles.css';

const DisplayIn = ({ navianceEnabled, caminoEnabled, onChange, value }) => {
  const intl = useIntl();
  const onCheckBoxChange = useCallback((e) => {
    const { target: { checked, name } } = e;
    onChange(e, {
      value: {
        ...value,
        [name]: checked,
      },
      name: 'displayIn',
    });
  }, [value]);

  return (
    <Form.Group inline styleName="event-input-displayin-container" arial-label={intl.formatMessage(messages.editEventDisplayIn)}>
      <Form.Field>
        <Checkbox
          data-cy="display-in-checkbox"
          id="eventDisplayInNaviance"
          name="naviancestudent"
          label={{
            htmlFor: 'eventDisplayInNaviance',
            children: (<FormattedMessage {...messages.editEventDisplayInNaviance} />),
          }}
          disabled={!navianceEnabled}
          checked={navianceEnabled && value?.naviancestudent}
          onChange={onCheckBoxChange}
        />
      </Form.Field>
      <Form.Field>
        <Checkbox
          data-cy="display-in-checkbox"
          id="eventDisplayInCamino"
          name="camino"
          label={{
            htmlFor: 'eventDisplayInCamino',
            children: (<FormattedMessage {...messages.editEventDisplayInCamino} />),
          }}
          disabled={!caminoEnabled}
          checked={caminoEnabled && value?.camino}
          onChange={onCheckBoxChange}
        />
      </Form.Field>
    </Form.Group>
  );
};

DisplayIn.displayName = 'DisplayIn';
DisplayIn.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.shape({
    naviancestudent: PropTypes.bool,
    camino: PropTypes.bool,
  }),
  navianceEnabled: PropTypes.bool.isRequired,
  caminoEnabled: PropTypes.bool.isRequired,
};

export default DisplayIn;
